function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import { SimpleContainer, CssContainer } from "../../components/container";
import { PageHeader, Ribbon, Card, Pill, Empty, Search, Filters, Delta, Pending } from "../../components/analytics-kit";
import { BaseDataViewComponentAsync, BaseGridViewComponent } from "../../components/base";
import publishSearch from '../../functions/publish-search';
import publishEvent from "../../functions/publish-event";
import { Loader } from '../../components/loaders';
import Error from '../../components/error';
import Query from "../../functions/query";
import ServiceFactory from '../../service';
import __JSONbigFactory from 'json-bigint';
var JSONbigString = __JSONbigFactory({
  storeAsString: true
});
import ResearchAssistantGrid from "../../components/research-assistant-grid";
class MainComponent extends BaseGridViewComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "onPageRequest", page => {
      this.gotoPage(page);
    });
    _defineProperty(this, "onButtonClick", event => {
      this.gotoPage('/Research/Assistant/Add');
    });
    _defineProperty(this, "onExportItem", (event, row) => {
      var id = JSONbigString.parse(row.id);
      //this.gotoPage('/Assistant/Run/' + id);
    });
    _defineProperty(this, "onDeleteItem", (event, row) => {
      if (confirm("Press OK to confirm Delete") == true) {
        this.deleteRow(row);
      }
    });
    _defineProperty(this, "deleteRow", row => {
      var id = JSONbigString.parse(row.id);
      var Service = ServiceFactory.getType('/research-assistant', 'research');
      var service = new Service();
      service.delete(id, (err, data) => {
        if (!err) {
          this.gotoPage('/Research/Assistant');
        }
      });
    });
  }
  componentDidMount() {
    publishSearch('Research');
    publishEvent('reset-search', {});
  }
  render() {
    var baseUrl = '/Research/Assistant';
    var refreshUrl = '/Research/Assistant';
    var data = this.props.data;
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view wa-view research-view"
    }, /*#__PURE__*/React.createElement(PageHeader, {
      crumbs: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Link, {
        to: "/Apps"
      }, "Apps"), " \xB7 Research Assistant"),
      title: "Research Assistant",
      subtitle: "Ask a research question and get a written answer with sources",
      chips: [{
        k: "Answers",
        v: String((data || []).length)
      }],
      actions: /*#__PURE__*/React.createElement("button", {
        className: "k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary",
        onClick: this.onButtonClick
      }, "New assistant")
    }), /*#__PURE__*/React.createElement(Card, {
      title: "Answers",
      cls: "wa-gridcard"
    }, /*#__PURE__*/React.createElement(ResearchAssistantGrid, {
      refreshUrl: refreshUrl,
      baseUrl: baseUrl,
      data: data,
      pagination: this.props.pagination,
      onPageRequest: this.onPageRequest,
      onExportItem: this.onExportItem,
      onDeleteItem: this.onDeleteItem
    })));
  }
}
export class ResearchAssistantViewComponent extends BaseDataViewComponentAsync {
  constructor(props) {
    super(props);
  }
  async fetchData() {
    let query = this.queryParams;
    let page = this.page;
    var api = '/research-assistant';
    var Service = ServiceFactory.getType(api, 'research');
    var service = new Service();
    var baseUrl = '/Research/Assistant';
    try {
      let data = await service.paginate({
        baseUrl: baseUrl,
        rawUrl: location.href,
        page: page,
        pageSize: 10
      }).orderBy(query.get('$orderBy')).orderByDesc(query.get('$orderByDesc')).getAsync();
      console.log(data);
      this.data = data.items;
      this.data.forEach(row => {
        let id = JSONbigString.parse(row.id);
        console.log(id);
      });
      this.pagination = data.pagination;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    } catch (err) {
      this.error = true;
      this.errorMessage = err.message;
      this.allowRender = true;
      this.allowUpdate = false;
      this.forceUpdate();
    }
  }
  render() {
    if (!this.allowRender) {
      return /*#__PURE__*/React.createElement(Loader, null);
    } else if (this.error) {
      return /*#__PURE__*/React.createElement(Error, {
        message: this.errorMessage
      });
    } else {
      return /*#__PURE__*/React.createElement(RoutableComponent, {
        data: this.data,
        pagination: this.pagination,
        params: this.props.params
      });
    }
  }
}
const RoutableComponent = withRouter(MainComponent);
export default {
  ResearchAssistantViewComponent
};